var _effectorFileName = "/builds/gmini/front-ui-kit/src/WithCursorIcon/WithCursorIcon.styled.ts";
import styled from 'styled-components';
import { Cursor as CursorInit } from '../icons/Cursor';
export const Wrapper = styled.div`
  display: flex;
  position: relative;
  height: min-content;
  width: min-content;
`;
export const Cursor = styled(CursorInit)`
  position: absolute;
  right: -14px;
  bottom: -29px;
`;